import * as React from 'react';
import { Underground } from '../../components/Underground';
import { Highway } from '../../components/Highway';
import { Railways } from '../../components/Railway';
import { getOfferType, isSuburban } from '../../utils/getOfferType';
import { ECategory, IGeoMobSiteSchema } from '../../types/recommendation';

interface IProps {
  geo: IGeoMobSiteSchema;
  category: ECategory;
}

export const GeoInformationContainer = ({ geo, category }: IProps) => {
  const { highways, undergrounds, railways, regionId } = geo;
  const isSuburbanOffer = React.useMemo(() => isSuburban(getOfferType(category)), [category]);

  if (!isSuburbanOffer) {
    // проверяем в порядке для города  метро / трасса

    if (undergrounds && undergrounds[0]) {
      return <Underground underground={undergrounds[0]} regionId={regionId} />;
    }

    if (highways && highways[0]) {
      return <Highway highway={highways[0]} />;
    }
  }

  if (isSuburbanOffer) {
    // проверяем в порядке для загородки  трасса / метро / электричка

    if (highways && highways[0]) {
      return <Highway highway={highways[0]} />;
    }

    if (undergrounds && undergrounds[0]) {
      return <Underground underground={undergrounds[0]} regionId={regionId} />;
    }

    if (railways && railways[0]) {
      return <Railways railway={railways[0]} />;
    }
  }

  return null;
};
